
import NormalHeader from '../../components/headers/NormalHeader'

type Props = {}

const SignupConfirmation = (props: Props) => {
  return (
    <div>
        <NormalHeader title={'Signup Successful'} />
    <div className="flex flex-col items-center justify-between mt-8 px-4 pb-2 md:px-0">
    <h2 className="text-xl font-bold text-primary mb-4">Email confirmation required:</h2>
    
  <div className="card">
    <div className="flex flex-col">
      <div className="overflow-x-auto">
        <div className="inline-flex min-w-full">
          <div className="w-full overflow-hidden p-4">
          <p>You have signed up successfully, but you <strong>need to confirm your email address to login.</strong></p>
            <p>Please check your email inbox (and spam folder) for the verification email.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  </div>
  )
}

export default SignupConfirmation